import { render, staticRenderFns } from "./FeatureFtuModal.vue?vue&type=template&id=1d1f0fc4&scoped=true&lang=html"
import script from "./FeatureFtuModal.vue?vue&type=script&lang=js"
export * from "./FeatureFtuModal.vue?vue&type=script&lang=js"
import style0 from "./FeatureFtuModal.vue?vue&type=style&index=0&id=1d1f0fc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1f0fc4",
  null
  
)

export default component.exports